/* „Nordijska zima“ – odbrojavanje, reveal, procjena dostave, plutajući gumb i gumb za pouzeće */
(() => {
  if (window.__bzZima) return;
  window.__bzZima = true;

  const pad = (n) => String(n).padStart(2, '0');

  function initCountdowns(root = document) {
    root.querySelectorAll('[data-bz-countdown]:not([data-ready])').forEach((el) => {
      el.setAttribute('data-ready', '');
      const target = new Date(el.getAttribute('data-bz-countdown')).getTime();
      if (Number.isNaN(target)) return;
      const out = (u) => el.querySelector(`[data-unit="${u}"]`);
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 86400000);
        diff -= d * 86400000;
        const h = Math.floor(diff / 3600000);
        diff -= h * 3600000;
        const m = Math.floor(diff / 60000);
        diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        if (out('d')) out('d').textContent = d;
        if (out('h')) out('h').textContent = pad(h);
        if (out('m')) out('m').textContent = pad(m);
        if (out('s')) out('s').textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function initReveal(root = document) {
    const items = root.querySelectorAll('.bz [data-bz-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach((el) => io.observe(el));
  }

  const fmt = new Intl.DateTimeFormat('hr-HR', { weekday: 'short', day: 'numeric', month: 'numeric', timeZone: 'Europe/Zagreb' });

  function addWorkingDays(from, days) {
    const d = new Date(from);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  }

  function initEta(root = document) {
    root.querySelectorAll('[data-bz-eta]').forEach((el) => {
      const min = parseInt(el.dataset.min, 10) || 1;
      const max = Math.max(min, parseInt(el.dataset.max, 10) || min);
      const out = el.querySelector('[data-bz-eta-range]');
      if (!out) return;
      const a = addWorkingDays(new Date(), min);
      const b = addWorkingDays(new Date(), max);
      out.textContent = min === max ? fmt.format(a) : `${fmt.format(a)} – ${fmt.format(b)}`;
    });
  }

  function initSticky(root = document) {
    const bar = root.querySelector('[data-bz-satc]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const scope = bar.closest('section') || document;
    const form = scope.querySelector('product-form') || scope.querySelector('form[action*="/cart/add"]');
    const realBtn = () => scope.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!form) return;
    // Fixed traka izvan roditelja s transformacijama/sticky kontekstom
    if (!window.Shopify?.designMode) document.body.appendChild(bar);
    bar.hidden = false;
    const priceOut = bar.querySelector('[data-bz-satc-price]');
    const btn = bar.querySelector('[data-bz-satc-btn]');
    const sync = () => {
      const p = scope.querySelector('.price .price-item--last, .price .price-item--regular');
      if (p && priceOut) priceOut.textContent = p.textContent.trim();
      const r = realBtn();
      if (r && btn) btn.disabled = r.disabled;
    };
    new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (passed) sync();
      bar.classList.toggle('is-visible', passed);
    }).observe(form);
    btn?.addEventListener('click', () => {
      const r = realBtn();
      if (r && !r.disabled) r.click();
      else form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Gumb aplikacije Releasit ima inline !important stilove; mijenjamo samo oblik, boja ostaje iz aplikacije
  function styleCodButton() {
    const btn = document.querySelector('.product__info-container #_rsi-buy-now-button, .product #_rsi-buy-now-button');
    if (!btn) return false;
    const apply = () => {
      if (btn.style.getPropertyValue('border-radius') === '999px') return;
      btn.style.setProperty('border-radius', '999px', 'important');
      btn.style.setProperty('min-height', '54px', 'important');
      btn.style.setProperty('font-weight', '700', 'important');
    };
    apply();
    new MutationObserver(apply).observe(btn, { attributes: true, attributeFilter: ['style'] });
    return true;
  }

  function initCodButton() {
    if (styleCodButton()) return;
    const mo = new MutationObserver(() => {
      if (styleCodButton()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  }

  function init(root) {
    initCountdowns(root);
    initReveal(root);
    initEta(root);
    initSticky(root);
    initCodButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
